import React from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import './Menu.css'
import Navbar from './navigation/Navbar';
import Categories from './Categories';
import Products from './Products';
import GlobalState from './GlobalState';

const Menu = () => {
    const { name } = useParams();
    if (name.length > 50) {
        return window.location = '/not-found';
    }

    return (
        <div>
            <GlobalState>
                <header className='public-header'>
                    <Navbar />
                </header>
                <div className='menu-layer'>
                    <section>
                        <Routes>
                            <Route exact path="/" element={<Categories />} />
                            <Route exact path="/archive" element={<Products />} />
                            <Route path="*" element={<Navigate replace to='/not-found' />} />
                        </Routes>
                    </section>
                </div>
            </GlobalState>
        </div>

    );
}

export default Menu;